/**
 * Ways a requester can choose to RECEIVE the money once the request is
 * fulfilled. In Phase 1 these are a static facade list; Phase 2 derives the
 * available options from a pre-quote against the destination corridor.
 */
export enum PayoutMethodType {
  BANK_ACCOUNT = "BANK_ACCOUNT",
  CASH_PICKUP = "CASH_PICKUP",
  PUSH_TO_CARD = "PUSH_TO_CARD",
  MOBILE_WALLET = "MOBILE_WALLET",
}

export interface IPayoutMethod {
  type: PayoutMethodType;
  /** Optional payer / network name (e.g. a specific bank or cash network). */
  payer?: string;
}
